import { IActivity } from '@sdk/contracts';
import { Button, Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';

import { ActionsWrapper, ActivityStatus, Cover, InfoWrapper, Wrapper } from './ActivityItem.styles';

import { Icon } from '@/components/Icon';
import { ACTIVITY_ICONS } from '@/constants';
import { useActivityPreview } from '@/hooks';
import { useComplementaryMaterialForm, useMutateActivity } from '@/store';

type Props = {
  activity: IActivity;
  sectionId: string;
};

export const ActivityItem: React.FC<Props> = ({ activity, sectionId }) => {
  const { t } = useTranslation('CourseTranslations');
  const { setActivity, setIsOpen } = useComplementaryMaterialForm();
  const { setActivityId } = useActivityPreview();
  const { removeActivity } = useMutateActivity();

  const handleEdit = () => {
    setActivity(activity);
    setIsOpen(true);
  };

  const handlePreview = () => setActivityId(activity._id);

  const handleRemoveActivity = () => {
    if (!activity) return;
    removeActivity({ activityId: activity._id, sectionId });
  };

  return (
    <Wrapper>
      <InfoWrapper>
        <Cover type={activity.type}>
          <Icon i={ACTIVITY_ICONS[activity.type]} />
          {activity.resource ? <ActivityStatus active={activity.active} /> : <Icon i="Warning" />}
        </Cover>
        <div>{activity.name}</div>
      </InfoWrapper>
      <ActionsWrapper>
        <Button type="link" size="small" icon={<Icon i="View" />} onClick={handlePreview} />
        <Button type="link" size="small" icon={<Icon i="Edit" />} onClick={handleEdit} />
        <Popconfirm title={t('DELETE_ACTIVITY_CONFIRM')} onConfirm={handleRemoveActivity}>
          <Button danger type="link" size="small" icon={<Icon i="TrashCan" />} />
        </Popconfirm>
      </ActionsWrapper>
    </Wrapper>
  );
};
